module.exports = __webpack_public_path__ + "static/media/imagemob.88e73202.jpeg";